<app-modal titleId="confirm-charge-title" (close)="close.emit()">
  <!-- HEADER con banda gris -->
  <header class="cc-header grid grid-cols-[1fr_auto] py-6 px-6">
    <section>
        <span class="text-neutral-600 text-2xl font-['Inter'] leading-normal">
          Confirma tu cobro
      </span>
      <span class="block text-neutral-600 text-sm font-['Inter'] leading-tight mt-2">
          Verifica los datos antes de continuar.
      </span>
    </section>
    <button type="button" class="w-6 h-6" aria-label="Cerrar" (click)="close.emit()">
      <img class="w-6 h-6" src="../../../assets/img/ic-close.svg" />
    </button>
  </header>
  <hr class="cc-divider" />

  <section class="cc-body">
    <!-- Tabla contenida en card con borde y radios -->
    <div class="summary-card">
      <table class="summary-table" role="table" aria-label="Resumen de cobro">
        <thead>
          <tr>
            <th scope="col">Documento de referencia</th>
            <th scope="col">Descripción</th>
            <th scope="col" class="amount">Monto</th>
          </tr>
        </thead>
        <tbody>
          @for (item of items; track $index) {
            <tr>
              <!-- Celda Documento: "N° de {docType} {reference}" en la MISMA celda -->
              <td>
                <span class="docref">
                  <span class="label">{{ item.documentType | docTypeLabel }}</span>
                  <span class="value">{{ item.documentNumber }}</span>
                </span>
              </td>
              <td>{{ item.description }}</td>
              <td class="amount">{{ item.amount | currencyClp }}</td>
            </tr>
          }
          <tr class="total-row">
            <td></td>
            <td class="total-label">Total a cobrar</td>
            <td class="amount total-amount">{{ total | currencyClp }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- FOOTER con botones a la derecha -->
  <footer class="cc-footer" modal-footer>
    <button type="button" (click)="onModify()" class="button-footer text-neutral-600 border-indigo-500 border-2 hover:bg-indigo-500 hover:text-white" > 
      Modificar
    </button>
    <button type="button" [disabled]="loading()" (click)="onStartPayment()" class="button-footer bg-indigo-500 text-white hover:bg-indigo-600 disabled:bg-neutral-400 " > 
      {{ loading() ? 'Iniciando…' : 'Continuar' }}
    </button>
  </footer>
</app-modal>

